export default __webpack_public_path__ + "static/media/maltese-cross.f5157e06.jpg";